/**
 * Clipboard utility functions
 */
/**
 * Copies text to the clipboard using the modern Clipboard API
 * Falls back to legacy method if Clipboard API is not available
 * @param text The text to copy to clipboard
 * @returns Promise that resolves to true if successful, false otherwise
 */
export async function copyToClipboard(text) {
    if (!text) {
        return false;
    }
    // Try modern Clipboard API first
    if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        }
        catch (error) {
            console.error('Error copying to clipboard:', error);
            // Fall through to legacy method
        }
    }
    // Fallback to legacy method for older browsers
    try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        return successful;
    }
    catch (error) {
        console.error('Error copying to clipboard (legacy method):', error);
        return false;
    }
}
